
export  const IDENTITY_SERVICES_PRODUCTS = {
     CARD_PRODUCT_SUBSCRIPTON : "CARD_PRODUCT_SUBSCRIPTON",
     TERMS_AND_CONDITIONS : "TERMS_AND_CONDITIONS",
}